import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/config/constants';
import { UserService } from 'src/app/core/services/user.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
declare var $;

@Component({
  selector: 'app-contract-sign',
  templateUrl: './contract-sign.component.html',
  styleUrls: ['./contract-sign.component.scss']
})
export class ContractSignComponent implements OnInit {
  signCard:boolean=true;
  iframemodel: boolean = false;
  error: any;
  urlSafe: SafeResourceUrl;
  stagesViews:any;
  isSignAgreement:boolean=false;
 isCompleted:boolean=false;
 checkedDoc: any;
 document_hash;
 leadStatus=""
 showContract: boolean = false;
 isUploaddoc: boolean = true;
 isCompleteddoc: boolean = true;
isInprogressUD: boolean = false;
  contractUrl: any;
  contractDownloadUrl: any;
  contractId: any;
  contractFileUrl: any;
  Url: any;
  deleteModal: any;
  showbtn: any;
  
  isCompletedSA: boolean = false;
  isPendingSA: boolean = false;
  isInprogressSA: boolean = false;
  isPendingOT: boolean = false;
  isCompletedOT: boolean = false;
  isInprogressOT: boolean = false;
  titleNavOT:string="";
  signedStatus: any;
  contractFileId: any;
  checkDocdesc: any;
  contractDetails: any=[];
  contarctPending: any=[];
  agreementId: any;

  constructor(public user:UserService,public config:Config,public router: Router) { 
    //this.stagesViews= JSON.parse(sessionStorage.getItem('stagesViews'))
    this.getDashboard();
  }
  
 ngOnInit(): void {
  this.leadId=sessionStorage.getItem('leadId');
  this.getDashboard();
  this.getEORequest();
  this.getVoidChequeRequest();
  this.getLicensRequest(); 
   this.DocmoreInfoReq(this.leadId);
  }

  checkStatus(){
     //  this.document_hash=undefined
       
     if(this.document_hash!=null || this.document_hash!=undefined){
      const formData = new FormData();
      formData.append('document_hash', this.document_hash);
      this.sendFormDataReq(formData);
    }
  }

  sendFormDataReq(formData: FormData){
    this.user.getSignerStatus(formData).pipe()
    .subscribe(
        data => {
            
          if(data.data !==undefined){
            let  tempRole
            let signerRole
          // let  tempRole=data.data.signers.filter(itm=>itm.role=="Lead" || "Partner")
          for(let m=0;m<data.data.signers.length;m++){
            if(data.data.signers[m].role=="Partner" || data.data.signers[m].role=="Lead" || this.contarctPending[0].signers[m].role=="Agent" || this.contarctPending[0].signers[m].role=="MGA Rep")
            {
             tempRole=data.data.signers[m];
            }
          }
          if(tempRole!=undefined || tempRole!=null){
        this.leadStatus=tempRole.status;
        signerRole=tempRole.role
         }
        
        //  if(this.leadStatus=="signed"){
        //   this.user.updateEverSignStatus(this.leadId,signerRole,this.agreementId).pipe()
        //   .subscribe(
        //       data => {
                  
        //         if(data.data !==undefined || data.status==true){
        //           this.getDashboard();  
        //           this.iframemodel = !this.iframemodel;
        //           // Swal.fire('',data.message,'success');
        //           window.location.reload();
        //           } },error=>{
        //             this.iframemodel = !this.iframemodel;
        //              this.error="Something went wrong. Please try again later";
        //            },()=>{});
        //         }
        //         else{
        //           //this.confirmBox();
        //          //this.iframemodel = !this.iframemodel;
        //         // this.confirmBox();
        //         //   setTimeout(function() {
        //         //     $('#successMessage').fadeOut('fast');
        //         // }, 30000); // <-- time in milliseconds
        //           //Swal.fire("", "Please Sign Agreement to Proceed further", 'warning')
                  
        //           // this.deleteLeadsPopup = !this.deleteLeadsPopup;
        //           this. closePopup();
        //         }
        this.iframemodel = !this.iframemodel;
        this.getDashboard();  
window.location.reload();
            }
           },error=>{
          if(error.status == 400 || error.status==417){
                this.error=error.error.data;
               }
             else{
               this.error=error.toString();
              
             }
           //  Swal.fire("", this.error , 'error')
            },()=>{});   
  }

  submitLeadAgreement(){
      
    // let signerRole="Lead"
    this.checkStatus();
    this.updateAgreementStatus();
  }
  updateAgreementStatus(){
    this.user.updateAgreementStatus(this.leadId).pipe()
    .subscribe(
        data => {
         
         console.log(data)
     
        },error=>{
          //  if(this.baseservice.handleError(error)){
             //handle Exception from Server 404,401
           
           
            },()=>{});
  }
  
  closePopup(){
    // this.deleteLeadsPopup = !this.deleteLeadsPopup;
    
     this.iframemodel = !this.iframemodel;
    // this.submitLeadAgreement();
  }

  deleteLeadsPopup: boolean=false;
  confirmBox(){
    Swal.fire({
      title: 'Are you sure want to close?',
      text: 'Please Sign Agreement to Proceed further',
      icon: 'warning',
      //showCancelButton: true,
      confirmButtonText: 'Yes',
      //cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        // Swal.fire(
        //   'Deleted!',
        //   'Your imaginary file has been deleted.',
        //   'success'
        // )
        this.iframemodel = !this.iframemodel;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // Swal.fire(
        //   'Cancelled',
        //   'Your imaginary file is safe :)',
        //   'error'
        // )
       // this.iframemodel = !this.iframemodel;
      }
    })
  }
showCard()
{
  this.signCard=false;
}
personalinfo: any;
getDashboard() {
  this.user.getDashboardData().pipe()
    .subscribe(
      data => {
          
        this.personalinfo = data.data.leads;
        if (this.personalinfo.stagesViews != null || undefined) {
          sessionStorage.setItem('stagesViews', JSON.stringify(this.personalinfo.stagesViews))
          this.stagesViews=this.personalinfo.stagesViews;
            
          this.getContract();
        }
        if (this.personalinfo.stagesViews[2].isCompleted === true && this.personalinfo.stagesViews[2].isApproved === true) {
              
          this.isCompletedSA=true;
          this.titleNavOT=""
         }
         if (this.personalinfo.stagesViews[2].isCompleted === false && this.personalinfo.stagesViews[2].isApproved === false) {
           
           this.isPendingSA=true;
           //this.titleNavOT="Online Training will be active once the uploaded Documents are approved"

         }
         if (this.personalinfo.stagesViews[2].isCompleted === true && this.personalinfo.stagesViews[2].isApproved === false) {

          
           this.isInprogressSA=true;
           //this.titleNavOT="Online Training will be active once the uploaded Documents are approved"
         }
         if (this.personalinfo.stagesViews[3].isCompleted === true && this.personalinfo.stagesViews[3].isApproved === true) {
          
           this.isCompletedOT=true;
         }
         if (this.personalinfo.stagesViews[3].isCompleted === false && this.personalinfo.stagesViews[3].isApproved === false) {
           
           this.isPendingOT=true;

         }
         if (this.personalinfo.stagesViews[3].isCompleted === true && this.personalinfo.stagesViews[3].isApproved === false) {

          
           this.isInprogressOT=true;
         }
         if(this.personalinfo.stagesViews[0].isCompleted === true &&
          this.personalinfo.stagesViews[0].isApproved === true   &&
       this.personalinfo.stagesViews[1].isCompleted === true &&
          this.personalinfo.stagesViews[1].isApproved === true   &&
      this.personalinfo.stagesViews[2].isCompleted === true &&
          this.personalinfo.stagesViews[2].isApproved === true &&
      this.personalinfo.stagesViews[3].isCompleted === true &&
          this.personalinfo.stagesViews[3].isApproved === true)
          {
           this.router.navigate(['/activated']);
     }
      }, error => {
      }, () => { });
}
checkStatusSA(){
  if(!this.signCard){this.iframemodel = !this.iframemodel;}
  else{
    Swal.fire('',"No Agreement Found.",'info')
  }
}
leadId;embeddedSigningUrl
getContract(){
  //var leadId=4;
    
  this.leadId=sessionStorage.getItem('leadId');
  this.user.getContractSignOFLead(this.leadId).pipe()
  .subscribe(
      data => {
            
          this.contractDetails=[];
          this.contarctPending=[]
        if(data.data !==undefined){
           
         for(let i=0; i<data.data.length;i++){
          this.contractDetails.push(data.data[i]);
          if(this.contractDetails[i].status!="Cancelled"){
            this.contarctPending.push(data.data[i])
        }
        
          }
          for(let m=0;m<this.contarctPending[0].signers.length;m++){
            if(this.contarctPending[0].signers[m].role=="Partner" ||this.contarctPending[0].signers[m].role=="Lead" || this.contarctPending[0].signers[m].role=="Agent" || this.contarctPending[0].signers[m].role=="MGA Rep")
            {
              this.signedStatus=this.contarctPending[0].signers[m].status
            }
          }
          this.agreementId = this.contarctPending[0].id
          this.checkedDoc = this.contarctPending[0].status
          this.checkDocdesc=this.contarctPending[0].description
          if (this.contarctPending[0].fileDownloadUrl != null) {
            if (this.contarctPending[0].files.length != 0) {
              // this.uploaddocs();
              // this.showExpiry = data.data.documents.expiryDate;
              // this.showDocumentName = data.data.documents.documentName;
              // this.showPolicyNumber = data.data.documents.policyNumber;
              // this.finalDocs = data.data.documents;
                  
              this.contractFileUrl = this.contarctPending[0].fileUrl;
              this.contractId = this.contarctPending[0].files.id
            
              this.contractFileId = this.contarctPending[0].fileId

              this.contractDownloadUrl =this.contarctPending[0].fileDownloadUrl;
              this.contractUrl = this.contractDownloadUrl.split('.').pop();
          
              this.checkedDoc = this.contarctPending[0].status
            this.checkDocdesc=this.contarctPending[0].description
            }
          }
            
          this.showbtn=this.personalinfo.stagesViews[2].isEditable
         if(this.stagesViews[1].isCompleted === true && this.stagesViews[1].isApproved===false){
          this.isUploaddoc = false;
          this.isCompleteddoc = true;
          this.isInprogressUD = true;
         }
          this.document_hash=this.contarctPending[0].documentHash;
          this.urlSafe="";
          if(this.contarctPending[0]=="No contract Found" || data.success==false){
            this.signCard=true;
          }
          else{
            this.signCard=false;
            if(this.stagesViews[2].isCompleted && this.stagesViews[2].isApproved && data.data.fileUrl!=null){
              if(this.stagesViews[2].isCompleted === true && this.stagesViews[2].isApproved===true){
                this.isSignAgreement = true;
                this.isCompleted=true;
                }else if(this.stagesViews[2].isCompleted === true && this.stagesViews[2].isApproved===false){
                  this.isSignAgreement = true;
                  this.isCompleted=false;
                }
              this.urlSafe= this.contarctPending[0].fileUrl;
            }
            else if(this.stagesViews[2].isCompleted === true && this.stagesViews[2].isApproved===false){
              this.isSignAgreement = true;
              this.isCompleted=false;
            }
              
              this.signCard=false;
              let temp=this.contarctPending[0].signers
              let tempRole
          //  let tempRole=temp.filter(itm=>itm.role=="Lead" ||  "Partner")
          //  let tempRole=temp.filter(itm=>itm.role=="Lead" || Prtner)
          for(let m=0;m<this.contarctPending[0].signers.length;m++){
            if(this.contarctPending[0].signers[m].role=="Partner" || this.contarctPending[0].signers[m].role=="Lead" || this.contarctPending[0].signers[m].role=="Agent" || this.contarctPending[0].signers[m].role=="MGA Rep")
            {
             tempRole=this.contarctPending[0].signers[m];
            }
          }
            if(tempRole!=undefined || tempRole!=null){
    
              this.embeddedSigningUrl=tempRole.embeddedSigningUrl
              this.urlSafe= this.embeddedSigningUrl;
            
            }
            else{ this.urlSafe=""}
          
           
          }
          
      }
         },error=>{
     
          if(error.status == 400 || error.status==417){
              this.error=error.error.data;
             
           }
           else{
             
             this.error="Something went wrong. Please check username and password.";
           }
           this.signCard=true;
          },()=>{});
}
onEoSelected(){
  this.contractFileId
  // this.Url = this.contractFileUrl;
  this.user.getLeadPreviewLink(this.contractFileId).pipe()
    .subscribe(
        data => {
            
        //  console.log(data.data)
         this.Url=data.data
     
        },error=>{
       
            if(error.status == 400 || error.status==417){
                this.error=error.error.data;
               
             }
             else{
               
               this.error="Something went wrong.";
             }
        
            },()=>{});
  setTimeout(() => 
{
  this.deleteModal = !this.deleteModal;
},
2000);
}

requestLicensarray=[]
getLicensRequest(){
    this.user.getLicenseRequestCall(this.leadId,'LINCENCES').pipe()
  .subscribe(
      data => {
        if(data.status==true){
        this.requestLicensarray=[]
        this.requestLicensarray=data.data
        }else{
        this.requestLicensarray=[]
        }
      },error=>{
          },()=>{});
  }
  DocmoreInfoReq(leadId){
    
    this.user.DocmoreInfoReq(leadId).pipe()
  .subscribe(
      data => {
        
          console.log(data.data);
          sessionStorage.setItem('DocmoreInfoReq', data.data)
      },error=>{
          },()=>{});
  }
 
  requestLicensarrayEO=[]
  getEORequest(){
      this.user.getLicenseRequestCall(this.leadId,'EO').pipe()
    .subscribe(
        data => {
          if(data.status==true){
          this.requestLicensarrayEO=[]
          this.requestLicensarrayEO=data.data
          }else{
          this.requestLicensarrayEO=[]
          }
        },error=>{
            },()=>{});
    }
    requestLicensarrayVoidCheque=[]
  getVoidChequeRequest(){
      this.user.getLicenseRequestCall(this.leadId,'VOID_CHEQUE').pipe()
    .subscribe(
        data => {
          if(data.status==true){
          this.requestLicensarrayVoidCheque=[]
          this.requestLicensarrayVoidCheque=data.data
          }else{
          this.requestLicensarrayVoidCheque=[]
          }
        },error=>{
            },()=>{});
    }
}
